export const ROSE_WATCH_ID = 618;
export const GUN_METAL_WATCH_ID = 619;
export const SPORTS_WATCH_ID = 617;
export const WATCH_HAND_SIZE_RATIO = 0.9;
